import { spacing } from '@upstox/upstox-ui';

export const ipoInfo: CSSFunction = ({ theme }) => ({
  marginBottom: spacing(theme, ['xsmall']),
  marginTop: spacing(theme, ['large']),
  '@media (min-width:768px)': {
    marginBottom: spacing(theme, ['xxlarge']),
    marginTop: spacing(theme, [44]),
  },
});
